import { Button, Typography, Box } from "@material-ui/core";
import { convertPriceToDollarFormat } from "../../../helpers/methods";
import floatButtonStyles from "./FloatButton.styles";
import glydeWhiteGif from "../../../assets/icons/glyde-loading-white.gif";
import strings from "../../constants/StringConstants";
import clsx from "clsx";

interface CustomProps {
  label: string;
  onClick: Function;
  noOfItems?: number;
  price?: number;
  loading?: boolean;
  customClasses?: string;
  disabled?: boolean;
}

const FloatingButton = (props: CustomProps) => {
  const classes = floatButtonStyles();
  const appliedClass = props.customClasses
    ? props.customClasses
    : classes.btnStyle;
  const processing = props.loading ? props.loading : false;
  const disabled = props.disabled ? props.disabled : false;

  const getFloatingButton = () => {
    return (
      <Box className={classes.floatingBtn}>
        <Button
          className={clsx({
            [appliedClass]: !disabled,
            [classes.disabledBtn]: disabled,
          })}
          onClick={() => {
            !processing && props.onClick();
          }}
          disabled={disabled}
        >
          {processing ? (
            <Box className={classes.loading}>
              <img
                src={glydeWhiteGif}
                alt={strings.glydeLoadingImage}
                className={classes.glydeGif}
              />
            </Box>
          ) : (
            <>
              <Typography className={classes.noOfItems}>
                {props.noOfItems !== undefined &&
                  props.noOfItems.toString() +
                    (props.noOfItems > 1 ? " items" : " item")}
              </Typography>
              <Typography className={classes.label}>{props.label}</Typography>
              <Typography className={classes.price}>
                {props.price !== undefined &&
                  convertPriceToDollarFormat(props.price)}
              </Typography>
            </>
          )}
        </Button>
      </Box>
    );
  };

  return getFloatingButton();
};

export default FloatingButton;
